import utils from '@eitje/utils'
import _ from 'lodash'
import {config} from '../config'

export async function createLocal(kind, items) {
	if (!_.isArray(items)) items = [items].filter(Boolean)
	if (items.length === 0) return
	config.store.dispatch({
		type: 'LOCAL_INDEX_RECORDS',
		items,
		kind: utils.snakeToCamel(kind),
	})
}

export async function destroyLocal(kind, id, {localKind} = {}) {
	const actKind = localKind || kind
	config.store.dispatch({
		type: 'DELETE_RECORD',
		id,
		kind: utils.snakeToCamel(actKind),
	})
}
